import { render, staticRenderFns } from "./PaymentsToku.vue?vue&type=template&id=edfb282e&scoped=true&"
import script from "./PaymentsToku.vue?vue&type=script&lang=js&"
export * from "./PaymentsToku.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsToku.vue?vue&type=style&index=0&id=edfb282e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edfb282e",
  null
  
)

export default component.exports